import { isString, isNumber } from '@antv/util';
import { Text } from '@antv/g';
export function renderExtDo(el) {
    return isString(el) || isNumber(el)
        ? new Text({
            style: {
                text: String(el),
            },
        })
        : el;
}
//# sourceMappingURL=extend-display-object.js.map